import { SupervisorAccount } from "@material-ui/icons";
import { observer } from "mobx-react-lite";
import { FunctionComponent, useContext, useEffect, useState } from "react";
import * as React from "react";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { authStoreContext } from "../../core/mainStore";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { customerContext } from "../customer/schema";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(5)
    }
  })
);

/**
 * CustomerOwnerContextLabel - shows identifier of currently shown Customer context for SAN Admin or Customer Owner selection
 */
export const CustomerOwnerContextLabel: FunctionComponent = observer(() => {
  const classes = useStyles();
  const auth = useContext(authStoreContext);
  const customer = useContext(customerContext);

  const customerListLink = "/admin/customers";
  const [customerName, setCustomerName] = useState("-");
  const [customerExternalId, setCustomerExternalId] = useState("-");

  useEffect(() => {
    setCustomerName(customer.oneDataSource.one?.name || "-");
    setCustomerExternalId(customer.oneDataSource.one?.externalId || "-");
  }, [customer.oneDataSource.one]);

  return (
    <>
      {auth.isAnyCustomerOwner() && (
        <span className={classes.label}>
          <Button
            to={customerListLink}
            variant={"text"}
            startIcon={<SupervisorAccount />}
            component={Link}
          >
            {`${customerName} [${customerExternalId}]`}
          </Button>
        </span>
      )}
    </>
  );
});
